export const SEND_EDOK_FORM_REQUEST = 'SEND_EDOK_FORM_REQUEST';

export const sendEdokFormRequest = ( id ) => ({
    type: SEND_EDOK_FORM_REQUEST,
    payload: {
        id
    }
});
